// @generated by protoc-gen-es v2.15.0 with parameter "target=ts"
// @generated from file responses/v1/ecom_scopes_response.proto (package responses.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';
import type { EcomScope } from '../../scopes/v1/ecom_scope_pb';
import { file_scopes_v1_ecom_scope } from '../../scopes/v1/ecom_scope_pb';
import type { Message } from '@bufbuild/protobuf';

/**
 * Describes the file responses/v1/ecom_scopes_response.proto.
 */
export const file_responses_v1_ecom_scopes_response: GenFile =
    /*@__PURE__*/
    fileDesc(
        'CidyZXNwb25zZXMvdjEvZWNvbV9zY29wZXNfcmVzcG9uc2UucHJvdG8SDHJlc3BvbnNlcy52MSI6ChJFY29tU2NvcGVzUmVzcG9uc2USJAoGc2NvcGVzGAEgAygOMhQuc2NvcGVzLnYxLkVjb21TY29wZUKCAQoQY29tLnJlc3BvbnNlcy52MUIXRWNvbVNjb3Blc1Jlc3BvbnNlUHJvdG9QAVoELi9wYqICA1JYWKoCDFJlc3BvbnNlcy5WMcoCDFJlc3BvbnNlc1xWMeICGFJlc3BvbnNlc1xWMVxHUEJNZXRhZGF0YeoCDVJlc3BvbnNlczo6VjFiBnByb3RvMw',
        [file_scopes_v1_ecom_scope]
    );

/**
 * @generated from message responses.v1.EcomScopesResponse
 */
export type EcomScopesResponse = Message<'responses.v1.EcomScopesResponse'> & {
    /**
     * @generated from field: repeated scopes.v1.EcomScope scopes = 1;
     */
    scopes: EcomScope[];
};

/**
 * Describes the message responses.v1.EcomScopesResponse.
 * Use `create(EcomScopesResponseSchema)` to create a new message.
 */
export const EcomScopesResponseSchema: GenMessage<EcomScopesResponse> =
    /*@__PURE__*/
    messageDesc(file_responses_v1_ecom_scopes_response, 0);
